import type { SplitShipmentDiscount } from "./split-shipment-discount";

// keep in sync with redo/backend/db/schema/src/team/ReFulfillmentSettings.ts

export enum ReFulfillmentBillingMode {
  PERCENTAGE = "percentage",
  FIXED = "fixed",
}

export interface ReFulfillmentBillingConfig {
  billingMode: ReFulfillmentBillingMode;
  revSharePercentage: number;
  fixedFeeAmount: number;
}

export interface ReFulfillmentShippingMarkupConfig {
  markupMode: ReFulfillmentBillingMode;
  markupPercentage: number;
  markupAmount: number;
}

export const reFulfillmentShippingMarkupDefault: ReFulfillmentShippingMarkupConfig =
  {
    markupMode: ReFulfillmentBillingMode.PERCENTAGE,
    markupPercentage: 10,
    markupAmount: 0,
  };

export interface ReFulfillmentSettings {
  /** @deprecated Use per-center `refulfillment` flag on ReturnsCenterConfig instead. */
  enabled?: boolean;
  redoOwned?: ReFulfillmentBillingConfig;
  merchantOwned?: ReFulfillmentBillingConfig;
  shippingMarkup?: ReFulfillmentShippingMarkupConfig;
  splitShipmentDiscount?: SplitShipmentDiscount;
}
